import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { ZIndex } from 'constants/zIndex';
import React from 'react';
import { css } from '@emotion/react';

export type MenuItem = {
  title: string;
  value?: any;
  disabled?: boolean;
  onClick?: (title: string, value?: any) => void;
};

interface MoreMenuListProps {
  className?: string;
  menu: MenuItem[];
  onClick?: () => void;
}

export const MoreMenuList = ({ className, menu, onClick }: MoreMenuListProps) => (
  <StyledMenuList className={className} onClick={onClick}>
    {menu.map(item => (
      <StyledMenuItem key={`${item.title}_${item.value ?? ''}`} disabled={!!item.disabled}>
        <button type="button" onClick={() => !item.disabled && item.onClick?.(item.title, item.value)}>
          {item.title}
        </button>
      </StyledMenuItem>
    ))}
  </StyledMenuList>
);

const StyledMenuList = styled.ul`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;

  width: 216px;
  padding: 8px 0;
  background-color: ${Color.White};
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  z-index: ${ZIndex.Modal};
`;

const StyledMenuItem = styled.li(
  ({ disabled }: { disabled: boolean }) => css`
    & button {
      text-align: left;
      margin: 0;
      padding: 0 16px;
      background-color: ${Color.White};
      width: 100%;
      height: 40px;
      border: none;
      cursor: pointer;
      ${Typography.XXSmall};

      color: ${disabled ? Color.Gray300 : Color.Black};

      &:hover {
        background-color: ${Color.Gray200};
      }

      &:active {
        background-color: ${Color.Gray200};
      }
    }
  `,
);
